import { ACTION_TYPE, ModalAction } from '../../actions/modal'

export type State = {
  open: boolean
  rewardId: string
}

export const initialState: State = {
  open: false,
  rewardId: '',
}

export function reducer(state = initialState, action: ModalAction): State {
  switch (action.type) {
    case ACTION_TYPE.TOGGLE_MODAL_REWARD: {
      return {
        ...state,
        open: action.isOpen,
        ...(action?.extra?.id && { rewardId: action.extra.id }),
      }
    }
    case ACTION_TYPE.SET_REWARD_ID: {
      return {
        ...state,
        rewardId: action.id,
      }
    }
    default:
      return state
  }
}
